export const TriangleSvg = () => (
  <svg
    width="20"
    height="10"
    viewBox="0 0 20 10"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10 10L0 0H20L10 10Z" fill="currentColor" />
  </svg>
);
